import { Link } from "react-router-dom";
import { formatPrice } from "../../utils/utils";
import BusinessTag from "../business/BusinessTag";
import { businessMarginPercent } from "../../utils/businessMargin";

const Article = ({ share = null, product, pricing = null, showBonPlanBadge = false }) => {
  const handleShare = (e) => {
    e.preventDefault();
    if (typeof share === "function") share();
  };

  const imageSrc = Array.isArray(product.image) ? product.image[0] : product.image;

  const displayPrice = product.prix > 0 ? product.prix : 0;

  const moq = Math.max(1, Number(product.minPurchase) || 1);

  // Le barème descend de la page : chaque carte le demandant pour son compte,
  // une grille de vingt produits déclencherait vingt appels au même endpoint.
  const marginPercent = product.isBusinessOffer && pricing
    ? businessMarginPercent(product.raw, pricing)
    : null;

  return (
    <div className="w-full bg-white rounded-xl overflow-hidden flex flex-col border border-gray-100 shadow-sm active:scale-[0.98] transition-transform">
      <Link to={`/produit-details/${product.id}`} className="block relative">
        <div className="aspect-square w-full overflow-hidden bg-gray-50">
          <img
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
            src={imageSrc}
            alt=""
            loading="lazy"
          />
        </div>

      </Link>

      {/* Le bouton de partage s'aligne sur la dernière ligne du bloc, quelle
          qu'elle soit (Min., Business, Bon plan) — jamais un décalage fixe,
          qui ne vaut que pour une combinaison de badges précise. */}
      {(() => {
        const lines = [
          <p key="price" className="text-black font-bold text-[13px]">
            {displayPrice > 0 ? formatPrice(displayPrice) : "Prix sur demande"}
          </p>,
        ];
        // Le minimum de commande se lit sur toutes les cartes — bons plans
        // compris : le prix seul ne dit pas ce qu'il faut sortir pour commander.
        if (moq > 0) {
          lines.push(
            <p key="moq" className="text-sm text-gray-500 font-medium mt-0.5">
              Min. {moq} unité{moq > 1 ? "s" : ""}
            </p>
          );
        }
        if (product.isBusinessOffer) {
          lines.push(
            <BusinessTag key="business" marginPercent={marginPercent} className="text-[11px] mt-0.5" />
          );
        }
        if (showBonPlanBadge) {
          lines.push(
            <span
              key="bonplan"
              className="inline-flex items-center px-2 py-0.5 rounded-full bg-sky-100 text-sky-700 text-[11px] font-semibold mt-0.5"
            >
              Bon plan
            </span>
          );
        }
        const lastLine = lines[lines.length - 1];
        const upperLines = lines.slice(0, -1);

        return (
          <div className="p-2 flex flex-col">
            {upperLines}
            <div className="flex items-center justify-between gap-1">
              <div className="flex-1 min-w-0">{lastLine}</div>
              <button
                onClick={handleShare}
                className="flex-shrink-0 w-7 h-7 flex items-center justify-center bg-orange-100 rounded-full hover:bg-orange-200 transition-colors"
                aria-label="Partager ce produit"
              >
                <i className="fi fi-rr-refer-arrow text-[12px] leading-none text-orange-500" />
              </button>
            </div>
          </div>
        );
      })()}
    </div>
  );
};

export default Article;
